import { render, staticRenderFns } from "./loans.vue?vue&type=template&id=6ee328ba&scoped=true"
import script from "./loans.vue?vue&type=script&lang=js"
export * from "./loans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee328ba",
  null
  
)

export default component.exports